import { Box, Typography } from "@mui/material";
import classes from './Variations.module.scss';
import { VariationsProps } from "../../interfaces/props/VariationsProps";
import VariationCard from "../../views/variation-card/VariationCard";

const Variations = ({ variations }: VariationsProps) => {
  return <Box className={`${classes.box} py-4 px-4`}>
    <Typography className='h4'>
      Variations ({variations.length})
    </Typography>
    <Box className='mt-3'>
      {variations.map((variation) => {
        return <VariationCard key={variation.id} variation={variation} image={''} />
      })}
    </Box>
  </Box>
};

export default Variations;
